export type LearningLocale = "en" | "zh-CN";

export function learningLocale(pathname: string): LearningLocale | undefined {
  if (pathname === "/zh-CN/learn" || pathname.startsWith("/zh-CN/learn/"))
    return "zh-CN";
  if (pathname === "/learn" || pathname.startsWith("/learn/")) return "en";
  return undefined;
}
export function unlocalizedLearningPath(pathname: string): string {
  return pathname.replace(/^\/zh-CN(?=\/learn(?:\/|$))/, "");
}
export function localizedLearningPath(
  path: string,
  locale: LearningLocale,
): string {
  const base = unlocalizedLearningPath(path);
  return locale === "zh-CN" ? `/zh-CN${base}` : base;
}
